import React from 'react'
import { Link, graphql } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import Header from '../components/header'
import Footer from '../components/footer'
import Seo from '../components/seo'
import CategoryBookingTile from '../components/category_booking_tile'

import capacityRangeIcon from '../../static/images/uploads/icon-product-capacity.jpg'
import engineTypeIcon from '../../static/images/uploads/icon-product-engin.jpg'
import contactIcon from '../../static/images/uploads/Enquiry.jpg'

const Entry = ({data}) => {
    const entry = data.markdownRemark
    return (
        <div className="page">
            <Seo title={entry.frontmatter.page_title} description={entry.frontmatter.meta_description} image="" pathname="/" />
            <Header />
            <div className="layout banner_bg grey">
                <div className="banner__container relative">
                    <div className="absolute banner_img">
                        <GatsbyImage image={entry.frontmatter.image.childImageSharp.gatsbyImageData} alt={entry.frontmatter.heading} style={{ width: "100%", height: "100%", display: "block" }} imgStyle={{ objectFit: "cover" }} />
                    </div>
                    <div className="banner relative">
                        <h2>{entry.frontmatter.section}</h2>
                    </div>
                </div>
            </div>
            <main className="layout entry grey">
                <div className="entry__container">
                    <div className="entry__flex flex__space-between">
                        <article className="article text">
                            {entry.frontmatter.row?.map((row, rowIndex) => (
                                row.product && (
                                    <div key={`row_${rowIndex}`} className="product-row">
                                        {row.product.map((product, productIndex) => (
                                            <div key={`product_${rowIndex}_${productIndex}`} className="product-card">
                                                {product.image?.childImageSharp && (
                                                    <GatsbyImage
                                                        image={product.image.childImageSharp.gatsbyImageData}
                                                        alt={product.product_name}
                                                        style={{ display: "block" }}
                                                        imgStyle={{ objectFit: "contain" }}
                                                    />
                                                )}
                                                <h3>{product.product_name}</h3>
                                                <div className="product-details">    
                                                    <div className="product-spec">
                                                        <div className="spec-item">
                                                            <img src={capacityRangeIcon} alt="Capacity Range" className="spec-icon" />
                                                            <span>{product.capacity_range}</span>
                                                        </div>
                                                        <div className="spec-item">
                                                            <img src={engineTypeIcon} alt="Engine Type" className="spec-icon" />
                                                            <span>{product.engine_type}</span>
                                                        </div>
                                                    </div>
                                                    <div className="product-footer">
                                                        <Link to={`/contact-us/?product=${product.product_name}`} className="contact-button">
                                                            <img src={contactIcon} alt="Contact Us" className="contact-icon" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )
                            ))}
                        </article>
                        <aside className="aside">
                            <CategoryBookingTile />
                            {entry.frontmatter.aside.map((item, i) => (
                                item.image?.childImageSharp && (
                                    <Link key={`item_${i}`} to={item.url} title={item.title}>
                                        <GatsbyImage
                                            image={item.image.childImageSharp.gatsbyImageData}
                                            alt={item.title}
                                            style={{ display: "block" }}
                                            imgStyle={{ objectFit: "contain" }}
                                        />
                                    </Link>
                                )
                            ))}
                        </aside>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default Entry;

export const query = graphql`
    query($slug: String!) {
        markdownRemark( fields: { slug: { eq: $slug } }) {
            frontmatter {
                section
                title
                page_title
                meta_description
                heading
                image {
                    childImageSharp {
                        gatsbyImageData(
                            width: 800, 
                            placeholder: NONE
                        )
                    }
                }
                row {
                    product {
                        image {
                            childImageSharp {
                                gatsbyImageData(width: 300, placeholder: BLURRED)
                            }
                        }
                        product_name
                        capacity_range
                        engine_type
                    }
                }
                aside {
                    image {
                        childImageSharp {
                            gatsbyImageData(width: 272, placeholder: NONE)
                        }
                    }
                    title
                    url
                }
            }
            fields {
                slug
            }
            html
        }
    }
`
